export default {
  name: "Task Name",
  buttons: {
    done: "SET AS DONE",
    backbtn: "Go Back",
    delete: "Delete",
    update: "Update"
  },
  messages: {
    notification: "The alarm is set to notify",
    frequency: "It has to be replaced every",
    before: "before",
    gotoProfile: "Go to inspection profile",
    deleteTask:
      "Once you delete a repository, there is no going back. Please be certain.",
    updateTask:
      "Once you update the task information, there is no going back. Please be certain."
  },
  labels: {
    tag: "Equipment Tag",
    global: "Global Task",
    recurrent: "Recurrent",
    onetime: "Onetime",
    maintenance: "Maintenance",
    repair: "Repair",
    reliability: "Reliability",
    done: "DONE",
    description: "Description",
    createdOn: "Task Created",
    frequency: "Task Frequency",
    due: "Due Date",
    notification: "Notificatiomn",
    danger: "Danger Zone",
    deleteTask: "Delete this task",
    updateTask: "Update task information"
  }
};
